<div *ngIf="!task" fxLayout="column" fxLayoutAlign="center center" fxFlex>
  <mat-icon class="s-120 mb-12 select-task-icon">check_box</mat-icon>
  <span class="mat-h1 select-task-text">Select a task</span>
</div>

<div
  *ngIf="task"
  class="px-32"
  fxLayout="column"
  fxLayoutAlign="start center"
  fxFlex="1 1 auto"
>
  <div
    class="task-header"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    *ngIf="this.dialogRef === null"
  >
    <div class="title">Task Details</div>
    <div class="actions" fxLayout="row" fxLayoutAlign="start center">
      <button
        mat-button
        class="mat-icon-button dialog-title"
        (click)="toggleStar($event)"
        aria-label="Toggle star"
        matTooltip="Toggle the Star flag"
        [disabled]="
          (task && task.taskStatus >= 30) || !this.dialogRef || !task?.readOnly
        "
      >
        <mat-icon class="star" *ngIf="task.starred">star</mat-icon>
        <mat-icon *ngIf="!task.starred">star_outline</mat-icon>
      </button>

      <button
        mat-button
        class="mat-icon-button dialog-title"
        (click)="toggleImportant($event)"
        aria-label="Toggle important"
        matTooltip="Toggle the Important flag"
        [disabled]="
          (task && task.taskStatus >= 30) || !this.dialogRef || !task?.readOnly
        "
      >
        <mat-icon class="important" *ngIf="task.important">error</mat-icon>
        <mat-icon *ngIf="!task.important">error_outline</mat-icon>
      </button>
    </div>
  </div>

  <div class="task-content" [ngStyle]="{ height: height }">
    <form [formGroup]="taskForm" (submit)="saveTask()">
      <div>
        <mat-form-field class="w-100-p">
          <mat-label>Summary</mat-label>
          <input
            matInput
            #summaryInput
            name="summary"
            formControlName="summary"
            maxlength="100"
            [setFocus]="true"
          />
        </mat-form-field>
        <validation-errors
          [control]="taskForm.get('summary')"
        ></validation-errors>
      </div>

      <div
        class="labels"
        fxFlexFill
        fxLayout="row wrap"
        *ngIf="
          inWidget === false &&
          task.subject != null &&
          task.subject.reference &&
          task.subject.reference.length > 0
        "
        style="padding: 0px 0px 4px 0px"
      >
        <a
          (click)="dialogRef.close()"
          [routerLink]="[
            '/subjects',
            this.subjectTypeService.getName(this.task.subject.subjectTypeId),
            this.task.subject.uid
          ]"
          class="label-label"
          >{{
            this.subjectTypeService.getName(this.task.subject.subjectTypeId)
          }}
          : {{ task.subject.reference }}
        </a>
      </div>

      <div
        class="info"
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <div fxFlex class="mr-8">
          <mat-form-field class="w-100-p">
            <mat-label>Task Type</mat-label>
            <mat-select
              class="form-control"
              formControlName="taskTypeId"
              required
            >
              <mat-option *ngFor="let item of taskTypes" [value]="item.id">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <validation-errors
            [control]="taskForm.get('taskTypeId')"
          ></validation-errors>
        </div>
        <mat-form-field fxFlex class="ml-8">
          <mat-label>Task Status</mat-label>
          <input
            matInput
            #taskStatusName
            taskStatusNameInput
            name="taskStatusName"
            formControlName="taskStatusName"
          />
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxFlex class="mr-8">
          <mat-form-field class="w-100-p">
            <mat-label>Action For</mat-label>
            <mat-select
              #cmbActionFor
              class="form-control"
              formControlName="actionForId"
              required
            >
              <mat-option *ngFor="let item of userList" [value]="item.id">
                {{ item?.fullName || 'Unspecified User' }}
              </mat-option>
            </mat-select>
            <!-- <mat-error *ngIf="formControl.invalid">Required</mat-error> -->
          </mat-form-field>
          <validation-errors
            [control]="taskForm.get('actionForId')"
          ></validation-errors>
        </div>

        <div id="divDateDue" fxFlex class="ml-8">
          <app-intec-date-picker
            id="datePickerDateDue"
            placeholder="Date Due"
            formControlName="dateDue"
            [max]="this.maxDate"
            [min]="this.minDate"
            [readonly]="this.allowEdit === false || this.task.taskStatus >= 30"
            class="form-control"
            required
          >
          </app-intec-date-picker>
          <validation-errors
            [control]="taskForm.get('dateDue')"
            [min]="this.minDate"
            [max]="this.maxDate"
          ></validation-errors>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between center">
        <mat-form-field
          *ngIf="(task && task.taskStatus >= 30) || !allowEdit"
          class="w-100-p"
        >
        <mat-label>Labels</mat-label>
          <input
            matInput
            #labelsInput
            name="labels"
            formControlName="labels"
            maxlength="500"
          />
        </mat-form-field>
        <mat-form-field
          *ngIf="task && !(task.taskStatus >= 30) && allowEdit"
          class="w-100-p"
        >
        <mat-label>Labels</mat-label>
          <mat-chip-grid #chipList aria-label="Labels">
            <mat-chip-row
              *ngFor="let label of labels"
              [selectable]="true"
              [removable]="true"
              (removed)="removeLabel(label)"
            >
              {{ label }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            <input
              #labelsInput
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="true"
              maxlength="20"
              (matChipInputTokenEnd)="addLabel($event)"
            />
          </mat-chip-grid>
        </mat-form-field>
        <!-- <validation-errors [control]="taskForm.get('labels')"></validation-errors> -->
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxFlex class="mr-8">
          <mat-form-field class="w-100-p">
            <mat-label>Created By</mat-label>
            <mat-select
              class="form-control"
              formControlName="createdById"
              ng-readonly="true"
            >
              <mat-option *ngFor="let item of userList" [value]="item.id">
                {{ item?.fullName || 'Unspecified User' }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex class="ml-8">
          <app-intec-date-picker
            placeholder="Date Created"
            formControlName="dateCreated"
            class="form-control"
          >
          </app-intec-date-picker>
          <validation-errors
            [control]="taskForm.get('dateCreated')"
          ></validation-errors>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxFlex class="mr-8">
          <mat-form-field class="w-100-p">
            <mat-label>Actioned By</mat-label>
            <mat-select
              class="form-control"
              placeholder="Actioned By"
              formControlName="actionedById"
            >
              <mat-option *ngFor="let item of userList" [value]="item.id">
                {{ item?.fullName || 'Unspecified User' }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <validation-errors
            [control]="taskForm.get('actionedById')"
          ></validation-errors>
        </div>
        <div fxFlex class="ml-8">
          <app-intec-date-picker
            *ngIf="task && task.taskStatus !== 40"
            placeholder="Date Completed"
            formControlName="dateCompleted"
            class="form-control"
          >
          </app-intec-date-picker>
          <validation-errors
            *ngIf="task && task.taskStatus !== 40"
            [control]="taskForm.get('dateCompleted')"
          ></validation-errors>
          <app-intec-date-picker
            *ngIf="task && task.taskStatus === 40"
            placeholder="Date Abandoned"
            formControlName="dateCompleted"
            class="form-control"
          >
          </app-intec-date-picker>
          <validation-errors
            *ngIf="task && task.taskStatus === 40"
            [control]="taskForm.get('dateCompleted')"
          ></validation-errors>
        </div>
      </div>
      <div>
        <mat-form-field class="w-100-p form-control">
          <mat-label>Notes</mat-label>
          <textarea
            matInput
            name="notes"
            formControlName="notes"
            rows="3"
            maxlength="500"
          >
          </textarea>
        </mat-form-field>
        <validation-errors
          [control]="taskForm.get('notes')"
        ></validation-errors>
      </div>

      <div mat-dialog-actions class="pt-24 pb-24">
        <button
          *ngIf="allowEdit === true && task && task.taskStatus < 30"
          [disabled]="!this.taskForm.valid || this.taskForm.pristine"
          mat-raised-button
          class="mat-accent"
        >
          SAVE
        </button>
      </div>
    </form>
  </div>
</div>
